import React from 'react'

import { SOLD_OUT_LABEL } from './constants'
import { countUnitsByStatus } from './level-explorer-util'
import useExplorerLevels from './use-explorer-levels'
import useLevelDisplayConfig from './use-level-display-config'

interface SelectedLevelCardProps {
  levelId: string
}

function SelectedLevelCard({ levelId }: SelectedLevelCardProps) {
  const { matchingLevelsById } = useExplorerLevels()
  const { levelStagePrefix, availableStatusLabel, availableStatusColour } =
    useLevelDisplayConfig()

  const level = matchingLevelsById.get(levelId)

  if (!level) {
    return null
  }

  const availableCount = countUnitsByStatus(level.data, availableStatusLabel)
  const hasAvailableUnits = availableCount > 0

  return (
    <div className="absolute right-5 top-5 z-20 flex h-[60px] w-[224px] flex-col justify-center gap-2 rounded-[10px] border-l-[5px] border-l-mainColour bg-white px-4 shadow-[5px_5px_5px_0_rgba(0,0,0,0.05)] desktop-all:h-[64px] desktop-all:w-[240px] desktop-large:h-[70px] desktop-large:w-[264px] desktop-large:gap-2.5 desktop-large:border-l-[6px] desktop-large:px-[18px]">
      <span className="truncate text-base font-bold leading-tight text-black desktop-all:text-lg desktop-large:text-xl">
        {levelStagePrefix} {level.level}
      </span>
      <span className="flex items-center gap-1 text-[11px] font-semibold uppercase leading-none tracking-[0.04em] text-[#666666] desktop-all:text-xs desktop-large:text-[13px]">
        {hasAvailableUnits && (
          <span
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: availableStatusColour }}
          />
        )}
        <span className="truncate">
          {hasAvailableUnits
            ? `${availableCount} ${availableStatusLabel}`
            : SOLD_OUT_LABEL}
        </span>
      </span>
    </div>
  )
}

export default SelectedLevelCard
